var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QrDialog',{attrs:{"url":_vm.url,"trigger":_vm.trigger},scopedSlots:_vm._u([{key:"activator",fn:function(scope){return [_vm._t("activator",function(){return [_c('div')]},null,scope)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }